import { UAParser } from 'ua-parser-js'

const LSKEY_UTYPE: string = 'jps-utype'
const BASE_URL = '/api/system/log/'
export const useLogStore = defineStore('logger', () => {
  const { fetchGet, fetchPost } = useCustomFetch()
  const privacyStore = usePrivacyStore()

  function sendFrontLog(log: FrontLog) {
    return fetchPost(BASE_URL + 'flog', log)
  }

  function getLogOrgSummary(dbId: string): Promise<any> {
    return fetchGet(BASE_URL + 'org-summary' + (dbId ? `?db=${dbId}` : ''))
  }

  function getPV(): Promise<any> {
    return fetchGet(BASE_URL + 'pv')
  }

  //ログのOn/Off
  let on: boolean = true
  function disableLog() {
    on = false
  }

  const result = new UAParser()

  let browser = ''
  try {
    browser = (
      result.getBrowser().name + result.getBrowser().major
    ).toLowerCase()
  } catch (e) {}

  const model =
    result.getDevice().model?.replace(/\s+/g, '').toLowerCase() || 'desktop'

  const os = result.getOS().name?.replace(/\s+/g, '').toLowerCase()

  const ua = model + '-' + os + '-' + browser
  let type = result.getDevice().type || 'pc'

  //botを判定して、botの場合にはログをOffに
  try {
    if (isBot()) {
      type = 'bot'
      disableLog()
    }
  } catch (e) {}

  // ユーザタイプ(User Random Type)
  let utype = lsGet(LSKEY_UTYPE) as string
  if (!utype) {
    utype = Math.random() < 0.5 ? '0' : '1'
    lsSet(LSKEY_UTYPE, utype)
  }

  function addErrorEvent(path: string, componentName: string, msg: string) {
    if (on) {
      addEvent({
        t: 'e',
        p: path,
        c: componentName,
        v: msg,
      })
    }
  }

  function addPageViewEvent(to: string) {
    if (on) {
      addEvent({ t: 'p', p: to })
    }
  }

  function addActionEvent(
    tag: string,
    path: string = undefined,
    value: string = undefined,
    componentName: string = undefined,
    element: string = undefined,
  ) {
    if (on) {
      addEvent({
        t: 'c',
        d: tag,
        p: path,
        v: value,
        c: componentName,
        e: element,
      })
    }
  }

  let events: FrontEvent[] = []

  function addEvent(e: FrontEvent) {
    if (on) {
      events.push(e)
      sendlogThrottle()
    }
  }

  function sendlog() {
    const tracking = privacyStore.gdprAcceptTracking
    sendFrontLog({ u: ua, d: type, t: tracking, a: utype, e: events })
    events = []
  }
  const sendlogThrottle = debounce(5000, sendlog)

  if (import.meta.client) {
    const stayTimeStart: number = new Date().getTime()
    window.addEventListener('beforeunload', () => {
      if (on) {
        const stayTime = '' + (new Date().getTime() - stayTimeStart) / 1000
        events.push({ t: 'c', d: 'stay-time', v: stayTime })
        sendlog()
      }
    })
  }

  return {
    getLogOrgSummary,
    getPV,
    addErrorEvent,
    addPageViewEvent,
    addActionEvent,
  }
})
